module.exports = {
      id: "tick-usage",
      viewBox: "0 0 23.788 23.787",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#tick",
      toString: function () {
        return this.url;
      }
    }